/* MICROHEALIX Performance — AJAX cart */
(function () {
  'use strict';

  const MICROHEALIX = window.MICROHEALIX || {};
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));
  const on = (el, ev, fn) => el && el.addEventListener(ev, fn);

  /* ---------- money formatter (Shopify-compatible) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const fmt = format || MICROHEALIX.moneyFormat || '${{amount}}';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      const parts = num.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }

    switch (fmt.match(placeholderRegex) ? fmt.match(placeholderRegex)[1] : '') {
      case 'amount':
        value = defaultTo(cents, 2);
        break;
      case 'amount_no_decimals':
        value = defaultTo(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = defaultTo(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = defaultTo(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = defaultTo(cents, 2, ' ', ',');
        break;
      default:
        value = defaultTo(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }
  window.Shopify = window.Shopify || {};
  if (!window.Shopify.formatMoney) window.Shopify.formatMoney = formatMoney;

  /* ---------- cart drawer open/close ---------- */
  const cartDrawer = $('#CartDrawer');
  const cartOverlay = $('[data-cart-overlay]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  window.microhealixCloseCart = closeCart;

  /* delegate clicks for open/close (markup re-renders) */
  on(document, 'click', (e) => {
    const openEl = e.target.closest('[data-cart-open]');
    if (openEl && MICROHEALIX.cartType !== 'page') {
      e.preventDefault();
      openCart();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      closeCart();
      return;
    }
    if (e.target === cartOverlay) closeCart();
  });

  /* ---------- bubble update ---------- */
  function updateBubble(count) {
    $$('[data-cart-bubble]').forEach((b) => {
      b.textContent = count;
      b.hidden = count === 0;
    });
  }

  /* ---------- re-render drawer via Section Rendering API ---------- */
  async function refreshCartDrawer(openAfter) {
    try {
      const res = await fetch(window.location.pathname + '?sections=cart-drawer');
      const data = await res.json();
      const html = data['cart-drawer'];
      if (html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh = parsed.querySelector('#CartDrawerInner');
        const current = $('#CartDrawerInner');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      }
    } catch (e) {
      // fallback: pull cart-ajax.js for the count
    }
    try {
      const cart = await (await fetch(MICROHEALIX.routes.cart_url + '.js')).json();
      updateBubble(cart.item_count);
    } catch (e) {}
    if (openAfter) openCart();
  }

  /* ---------- add to cart (quick-add + product form) ---------- */
  async function addToCart(payload, button) {
    if (button) button.classList.add('is-loading');
    try {
      const res = await fetch(MICROHEALIX.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const err = await res.json();
        window.microhealixToast && window.microhealixToast(err.description || 'Could not add to bag');
        return;
      }
      await refreshCartDrawer(true);
      window.microhealixToast && window.microhealixToast(MICROHEALIX.strings.addedToBag || 'Added to bag');
    } catch (e) {
      window.microhealixToast && window.microhealixToast('Network error');
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }

  /* quick-add buttons (delegated) */
  on(document, 'click', (e) => {
    const qa = e.target.closest('[data-quick-add]');
    if (!qa || qa.disabled) return;
    e.preventDefault();
    const id = qa.getAttribute('data-quick-add');
    if (!id) return;
    addToCart({ items: [{ id: parseInt(id, 10), quantity: 1 }] }, qa);
  });

  /* product form submit */
  $$('[data-product-form] form').forEach((form) => {
    on(form, 'submit', (e) => {
      e.preventDefault();
      const idInput = form.querySelector('[data-variant-id]');
      const qtyInput = form.querySelector('[data-pf-qty-input]');
      const id = idInput ? idInput.value : null;
      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!id) return;
      const atc = form.querySelector('[data-atc]');
      addToCart({ items: [{ id: parseInt(id, 10), quantity: qty }] }, atc);
    });
  });

  /* ---------- change quantity (delegated, keyed by item.key) ---------- */
  async function changeLine(key, quantity) {
    try {
      const res = await fetch(MICROHEALIX.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      });
      await res.json();
      await refreshCartDrawer(false);
      // if on full cart page, reload to reflect totals
      if (document.body.classList.contains('template-cart')) window.location.reload();
    } catch (e) {
      window.microhealixToast && window.microhealixToast('Could not update bag');
    }
  }

  on(document, 'click', (e) => {
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const key = qtyBtn.getAttribute('data-qty-change');
      const dir = qtyBtn.getAttribute('data-qty-dir');
      const input = $('[data-qty-input="' + CSS.escape(key) + '"]');
      let v = input ? parseInt(input.value, 10) || 1 : 1;
      v = dir === 'up' ? v + 1 : v - 1;
      if (v < 0) v = 0;
      changeLine(key, v);
      return;
    }
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      const key = removeBtn.getAttribute('data-cart-remove');
      changeLine(key, 0);
      window.microhealixToast && window.microhealixToast(MICROHEALIX.strings.itemRemoved || 'Item removed');
    }
  });
})();
